module.exports = __webpack_public_path__ + "assets/img/busy_9.112e8547.png";